import { gql } from '@apollo/client'

import { ProductWithOfferFragmentDoc } from '@shared/generated'

/*
  Product queries a landing `products` block may drive through payload.query.

  The landing payload is a thin description of a standard catalog request
  (query + categoryId/filter + pager + sort), so these documents mirror the
  arguments each backend query actually accepts. They are declared here rather
  than reusing the generated hooks because the generated documents omit some of
  those arguments (e.g. popularProducts has no filter, saleProducts has no pager
  variables wired for landings).

  IMPORTANT — argument support differs per query (customer schema, product.gql):
    products         : category_id, filter, sort, pager
    popularProducts  : filter, pager            (no category_id, no sort)
    saleProducts     : pager                    (no filter, no category_id)
  Passing an unsupported argument is a hard GraphQL error, so the block maps the
  payload onto only what the chosen query supports (see resolveProductsQuery).
*/

export const GQL_LANDING_PRODUCTS = gql`
  query LandingProducts(
    $shopId: ID!
    $style: String
    $categoryId: ID
    $filter: NestedFilterInput
    $sort: CommonSortInput
    $pager: CommonPagerInput
  ) {
    products(
      shop_id: $shopId
      category_id: $categoryId
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ...ProductWithOffer
      }
    }
  }
  ${ProductWithOfferFragmentDoc}
`

export const GQL_LANDING_POPULAR_PRODUCTS = gql`
  query LandingPopularProducts(
    $shopId: ID!
    $style: String
    $filter: NestedFilterInput
    $pager: CommonPagerInput
  ) {
    popularProducts(shop_id: $shopId, filter: $filter, pager: $pager) {
      edges {
        ...ProductWithOffer
      }
    }
  }
  ${ProductWithOfferFragmentDoc}
`

export const GQL_LANDING_SALE_PRODUCTS = gql`
  query LandingSaleProducts(
    $shopId: ID!
    $style: String
    $pager: CommonPagerInput
  ) {
    saleProducts(shop_id: $shopId, pager: $pager) {
      edges {
        ...ProductWithOffer
      }
    }
  }
  ${ProductWithOfferFragmentDoc}
`
